var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPropertyMultiple = function SvgPropertyMultiple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.549 4 6.45 6.406-.705.71-5.745-5.707-2.472 2.455-.705-.71zM8.45 5.934 2 12.34l.705.71 5.744-5.707 5.745 5.706.705-.71zM4.848 14.08V19h7.203v-4.92h1V20H3.848v-5.92zM19.16 12.135v4.921h-4.085v1h5.085v-5.92z"
  })));
};
export default SvgPropertyMultiple;